import React from "react";
import { Link } from "react-router";
import { TextField, CircularProgress, RaisedButton } from "material-ui";
import assign from "lodash/assign";
import chunk from "lodash/chunk";
import { colors } from "material-ui/styles";
import Helmet from "react-helmet";
import api from "../utils/api";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonActions from "../actions/PersonActions";
import PersonStore from "../stores/PersonStore";

import { capitalize, formatPrice, isApp } from "../util";
import InjectedTenantHTML from "./partials/injected-tenant-html.jsx";
import Datepicker from "./partials/datepicker.jsx";
import moment from "moment";
import EditorFormatAlignJustify from "material-ui/svg-icons/editor/format-align-justify";

@connectToStores
class GiftCards extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isNative: false,
      cardNumber: "",
      showCardBalance: false,
      cardBalance: 0,
      cardBalanceError: null,
      senderName: "",
      recipientName: "",
      recipientEmail: "",
      senderNameError: false,
      recipientNameError: false,
      recipientEmailError: false,
      giftMessage: "",
      giftScheduledSend: moment
        .tz(new Date(), moment.tz.guess())
        .format("YYYY-MM-DD")
    };

    this.getStyles = this.getStyles.bind(this);
    this.handleCheckBalance = this.handleCheckBalance.bind(this);
    this.validateFields = this.validateFields.bind(this);
    this.clearFields = this.clearFields.bind(this);
    this._renderGiftCardButtons = this._renderGiftCardButtons.bind(this);
  }

  static get contextTypes() {
    return {
      appSettings: React.PropTypes.object,
      muiTheme: React.PropTypes.object,
      router: React.PropTypes.object.isRequired,
      tenant: React.PropTypes.object,
      isLarge: React.PropTypes.bool
    };
  }

  static getStores() {
    return [PersonStore];
  }

  static getPropsFromStores() {
    return PersonStore.getState();
  }

  componentDidMount() {
    // Native app - force redirect
    if (navigator.userAgent.indexOf("gonative") > -1) {
      window.open(window.location.href + "?external", "_blank");
      this.setState({ isNative: true });
    } else {
      this.componentWillReceiveProps(this.props);
    }
  }

  componentWillReceiveProps(newProps) {
    var person = newProps.details;
    this.setState({ senderName: person && person.name ? person.name : "" });
  }

  getStyles() {
    let primaryColor = this.context.muiTheme.rawTheme.palette.primary1Color,
      { isLarge } = this.context;

    return {
      loading: {
        padding: "30px 10px",
        textAlign: "center"
      },
      appMessage: {
        padding: 10,
        paddingTop: 30,
        textAlign: "center",
        fontSize: "12pt"
      },
      container: {
        padding: 10
      },
      title: {
        textAlign: "center",
        fontSize: 30
      },
      giftCardContainer: {
        display: "flex",
        flexWrap: "wrap"
      },
      giftCardPurchaseContainer: {
        textAlign: "center",
        flex: 2,
        paddingBottom: 40,
        marginRight: 20
      },
      giftCardCheckBalanceContainer: {
        textAlign: "center",
        flex: 1
      },
      giftCardSectionHeader: {
        fontSize: "1.25em",
        fontWeight: "bold",
        marginTop: 20,
        textAlign: "center"
      },
      giftCardButtonsContainer: {
        marginTop: "2em",
        textAlign: "center"
      },
      giftCardButton: {
        marginRight: 10,
        marginTop: 15,
        minWidth: 90,
        height: 50
      },
      giftCardButtonLabel: {
        fontSize: "1.25em"
      },
      giftCardTextFieldWrapper: {
        marginTop: 20,
        textAlign: "center"
      },
      giftCardDateFieldWrapper: {
        marginTop: 12,
        textAlign: "center",
        display: "flex",
        justifyContent: "center"
      },
      giftCardTextField: {
        height: 40,
        width: 360,
        marginRight: 25
      },
      giftCardTextArea: {
        width: 360,
        marginRight: 25
      },
      checkBalancePanel: {
        display: "inline-block",
        border: "1px solid black",
        width: 370,
        marginTop: 35,
        padding: 25,
        backgroundColor: "#eee",
        textAlign: "left"
      },
      checkBalanceLabel: {
        marginBottom: 15,
        fontSize: "1.25em"
      },
      checkBalanceTextFieldWrapper: {
        height: 40,
        width: "100%",
        padding: 5,
        paddingBottom: 0,
        backgroundColor: "#fff"
      },
      checkBalanceTextField: {
        height: 40,
        width: "100%"
      },
      checkBalanceStatus: {
        marginTop: 20,
        marginBottom: 10,
        fontSize: "1.10em",
        fontWeight: "bold"
      },
      checkBalanceError: {
        marginTop: 20,
        marginBottom: 10,
        fontSize: "1.10em",
        fontWeight: "bold",
        color: "#f00"
      }
    };
  }

  validateFields() {
    let isValid = true;
    if (this.state.senderName === "") {
      this.setState({
        senderNameError: "Please include a name for the sender."
      });
      isValid = false;
    }
    if (this.state.recipientName === "") {
      this.setState({
        recipientNameError: "Please include a name for the recipient."
      });
      isValid = false;
    }
    if (this.state.recipientEmail === "") {
      this.setState({
        recipientEmailError:
          "Please include an email address for the recipient."
      });
      isValid = false;
    } else if (
      !this.state.recipientEmail.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
    ) {
      this.setState({
        recipientEmailError:
          "Please include a valid email address for the recipient."
      });
      isValid = false;
    }
    return isValid;
  }

  clearFields() {
    this.setState({
      senderNameError: false,
      recipientNameError: false,
      recipientEmailError: false
    });
  }

  handleCheckBalance() {
    this.setState({});
    this.setState({
      cardBalanceError: null,
      cardBalance: 0,
      showCardBalance: false
    });

    if (this.state.cardNumber.trim() === "") {
      this.setState({
        cardBalanceError: "Please enter a valid gift card number"
      });
      return;
    }

    api.request(
      {
        method: "GET",
        endpoint: `/gift_cards/check_balance/${this.state.cardNumber.trim()}`
      },
      function (err, response) {
        if (err) {
          this.setState({ cardBalanceError: err.message });
        } else {
          this.setState({
            cardBalance: response.balance,
            showCardBalance: true
          });
        }
      }.bind(this)
    );
  }

  _renderGiftCardButtons() {
    let styles = this.getStyles();

    return (
      <div style={styles.giftCardButtonsContainer}>
        {this.context.tenant.gift_cards_purchase_levels.map(level => {
          return (
            <RaisedButton
              className="eventive__donate-button__button"
              style={styles.giftCardButton}
              labelStyle={styles.giftCardButtonLabel}
              primary={true}
              label={formatPrice(level.amount, /* short */ true)}
              onClick={() => {
                this.clearFields();
                if (!this.validateFields()) {
                  return;
                }

                this.context.router.push({
                  pathname: "/giftcards/go",
                  query: {
                    amount: level.amount,
                    senderName: this.state.senderName,
                    recipientName: this.state.recipientName,
                    recipientEmail: this.state.recipientEmail,
                    giftMessage: this.state.giftMessage,
                    giftScheduledSend: this.state.giftScheduledSend
                  },
                  state: { fromMainListing: true }
                });
              }}
            />
          );
        })}
        {this.context.tenant.gift_cards_show_other ? (
          <RaisedButton
            style={Object.assign({}, styles.giftCardButton, { marginRight: 0 })}
            labelStyle={styles.giftCardButtonLabel}
            label="Other"
            className="eventive__donate-button__button eventive__donate-button__button--other"
            onClick={() => {
              this.clearFields();
              if (!this.validateFields()) {
                return;
              }

              const senderName = this.state.senderName;
              const recipientName = this.state.recipientName;
              const recipientEmail = this.state.recipientEmail;
              const giftMessage = this.state.giftMessage;
              const giftScheduledSend = this.state.giftScheduledSend;

              // clear field values
              this.setState({
                senderName: "",
                recipientName: ""
              });

              this.context.router.push({
                pathname: "/giftcards/go",
                query: {
                  senderName: senderName,
                  recipientName: recipientName,
                  recipientEmail: recipientEmail,
                  giftMessage: giftMessage,
                  giftScheduledSend: giftScheduledSend
                },
                state: { fromMainListing: true }
              });
            }}
          />
        ) : null}
      </div>
    );
  }

  render() {
    if (
      !this.context.tenant.gift_cards_enabled ||
      !this.context.tenant.gift_cards_frontend_enabled
    ) {
      this.context.router.push("/");
      return <div></div>;
    }

    let styles = this.getStyles();

    /*if (isApp()) {
      return (
        <div style={styles.appMessage}>
          This functionality is not available in the App.
        </div>
      );
    }*/

    if (this.state.isNative) {
      return <div style={styles.loading}>Thank you for your purchase.</div>;
    }

    return (
      <div>
        <Helmet
          title={this.context.tenant.gift_card_page_title || "Gift Cards"}
        />
        {this.props.children
          ? React.cloneElement(this.props.children, {
              appSettings: this.props.appSettings
            })
          : undefined}

        <div style={styles.container}>
          <h2 style={styles.title}>
            {this.context.tenant.gift_cards_page_title || "Gift Cards"}
          </h2>
          <InjectedTenantHTML
            content={this.context.tenant.gift_cards_page_content}
          />
          <div style={styles.giftCardContainer}>
            <div style={styles.giftCardPurchaseContainer}>
              <div style={styles.giftCardSectionHeader}>
                Purchase a Gift Card
              </div>
              <div>
                <div style={styles.giftCardTextFieldWrapper}>
                  <TextField
                    placeholder="Sender Name"
                    errorText={this.state.senderNameError}
                    style={styles.giftCardTextField}
                    value={this.state.senderName}
                    onChange={e => {
                      this.setState({ senderName: e.target.value });
                    }}
                  />
                </div>

                <div style={styles.giftCardTextFieldWrapper}>
                  <TextField
                    placeholder="Recipient Name"
                    errorText={this.state.recipientNameError}
                    style={styles.giftCardTextField}
                    value={this.state.recipientName}
                    onChange={e => {
                      this.setState({ recipientName: e.target.value });
                    }}
                  />
                </div>

                <div style={styles.giftCardTextFieldWrapper}>
                  <TextField
                    placeholder="Recipient Email Address"
                    errorText={this.state.recipientEmailError}
                    style={styles.giftCardTextField}
                    value={this.state.recipientEmail}
                    onChange={e => {
                      this.setState({ recipientEmail: e.target.value });
                    }}
                  />
                </div>

                <div style={styles.giftCardTextFieldWrapper}>
                  <TextField
                    placeholder="Message (Optional)"
                    multiLine={true}
                    variant="outlined"
                    style={styles.giftCardTextArea}
                    value={this.state.giftMessage}
                    inputProps={{ maxLength: 12 }}
                    onChange={e => {
                      // limit the message to 200 characters
                      if (e.target.value.length > 200) {
                        return;
                      }
                      this.setState({ giftMessage: e.target.value });
                    }}
                  />
                </div>

                <div style={styles.giftCardDateFieldWrapper}>
                  <Datepicker
                    label="Schedule Send Date"
                    displayFormat="MM/DD/YYYY"
                    fullWidth={false}
                    value={this.state.giftScheduledSend}
                    onChange={v => {
                      this.setState({ giftScheduledSend: v });
                    }}
                    style={styles.giftCardTextField}
                    minDate={new Date()}
                  />
                </div>

                {this._renderGiftCardButtons()}
              </div>
            </div>
            <div style={styles.giftCardCheckBalanceContainer}>
              <div style={styles.giftCardSectionHeader}>Check Your Balance</div>
              <div style={styles.checkBalancePanel}>
                <div style={styles.checkBalanceLabel}>
                  Enter card number to view your current balance
                </div>
                <div style={{ marginTop: 10 }}>
                  <div style={styles.checkBalanceTextFieldWrapper}>
                    <TextField
                      label="Card #"
                      style={styles.checkBalanceTextField}
                      onChange={e => {
                        this.setState({ cardNumber: e.target.value });
                      }}
                    />
                  </div>
                </div>
                {this.state.showCardBalance ? (
                  <div style={styles.checkBalanceStatus}>
                    {formatPrice(this.state.cardBalance)}
                  </div>
                ) : null}
                {this.state.cardBalanceError ? (
                  <div style={styles.checkBalanceError}>
                    {this.state.cardBalanceError}
                  </div>
                ) : null}
                <RaisedButton
                  className="eventive__donate-button__button"
                  style={styles.giftCardButton}
                  labelStyle={styles.giftCardButtonLabel}
                  primary={true}
                  label="Check Balance"
                  onClick={this.handleCheckBalance}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GiftCards;



// WEBPACK FOOTER //
// ./src/app/components/gift-cards.jsx